<template>
  <well :severity="error ? 'warning' : ''">
    <p class="message">
      {{ message }}
    </p>
    <ul v-if="error">
      <li>
        {{ error }}
      </li>
    </ul>
  </well>
</template>

<script>
import { signout } from '@/redirect';

import Well from './elements/Well';

export default {
  components: {
    well: Well,
  },

  props: {
    callback: { type: String, default: '' },
    state: { type: String, default: '' },
  },

  data() {
    return {
      error: null,
    };
  },

  computed: {
    message: function statusMessage() {
      const successMessage = this.app ?
        `Signing you out of ${this.app}, please wait...` :
        'Signing you out, please wait...';

      return this.error ?
        'Whoops, something went wrong. This is probably not your fault:' :
        successMessage;
    },

    app: function parseCallback() {
      const domain = /^https?:\/\/([^/]+)/.exec(this.callback);
      return domain ? domain[1] : this.callback;
    },
  },

  // trigger signout immediately
  mounted() {
    signout({
      next: this.callback,
      state: this.state,
      error: (err) => {
        this.error = err;
      },
      internalRedirect: () => {
        this.$router.push('/');
      },
    });
  },
};

</script>

<style scoped>
.message {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue